import React from "react";
import Project from "./Project";

const SelectedProject = ({ project, isExpanded, isReady }) => {
  return <Project project={project} />;
};

export default SelectedProject;
